const isLegacyBrowserDetected = () => {
  return /msie\s|trident\//i.test(window.navigator.userAgent);
};

export const isEdge = () => window.navigator.userAgent.includes(`Edg`);

export default isLegacyBrowserDetected;
